export const Terms = {
  Customer: {
    label: 'Customer',
    plural: 'Customers',
  },
};
